import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import { boolTrue } from 'Consts/Strings';

const styles = (theme) => ({
  root: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gridTemplateColumns: '1fr 1fr',
    paddingBottom: theme.spacing(2),
  },
  header: {
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(2),
    gridColumn: 'span 2',
  },
  match: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  noMatch: {
    color: theme.palette.facet.alertRed,
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const ResultsContent = ({
  className,
  classes,
  resource,
}) => {
  const renderMatchResultComponent = (matchResultResource, resultClassName) => {
    return (
      <>
        <Typography
          color="primaryGray"
          variant={'h5'}
          className={resultClassName}
        >
          {matchResultResource.attr('bankValue')}
        </Typography>
        <Typography
          color="primaryGray"
          variant={'h5'}
          className={resultClassName}
        >
          {matchResultResource.attr('clearingHouseValue')}
        </Typography>
      </>
    );
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography className={classes.header} variant={'h3'} color={'primary'}>
        {'Match Results'}
      </Typography>

      {resource?.attr('matchResults')?.resources()?.list().map((matchResultResource) => {
        if (matchResultResource.attr('isMatch') !== boolTrue) {
          return renderMatchResultComponent(matchResultResource, classes.noMatch);
        }
        return renderMatchResultComponent(matchResultResource, classes.match);
      })}
    </Box>
  );
};

ResultsContent.defaultProps = {
  className: '',
};

ResultsContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResultsContent);
